/** Display helpers for the phone desk. */

/** "Fri, Oct 30" for a date-only string, read as a calendar day (no timezone shift). */
export function fmtDay(dateStr: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateStr);
  if (!m) return dateStr;
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12));
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

/** "Oct 28, 2:14 PM" in Pacific time. */
export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'America/Los_Angeles',
  });
}

const STATUS: Record<string, string> = {
  submitted: 'Received',
  accepted: 'Accepted',
  scheduled: 'Scheduled',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
  invoiced: 'Delivered',
  cancelled: 'Cancelled',
  rejected: 'Not accepted',
};
export function orderStatusLabel(status: string): string {
  return STATUS[status] ?? status;
}

const KIND: Record<string, string> = {
  equipment_issue: 'Equipment issue',
  refill: 'Refill / CO₂',
  scheduling: 'Scheduling',
  other: 'Other',
};
export function serviceKindLabel(kind: string): string {
  return KIND[kind] ?? kind;
}

export const SERVICE_KINDS = Object.entries(KIND) as Array<[
  'equipment_issue' | 'refill' | 'scheduling' | 'other',
  string,
]>;
